import React from "react";
import {
  AddProductMutation,
  UpdateProductMutation,
  useAddProductMutation,
} from "@apollo/ops";
import { Button } from "@ui/Button";
import { Dialog, useDialog } from "@ui/Dialog";
import { ProductForm, ProductFormSubmitData } from "../ProductForm";
import { toast } from "@utilities/toast";
import { MessageSeverity } from "@shared/types/Severity";
import { getMessageToUserFromBackendError } from "@utilities/i18n";
import { toCents } from "@util/currency";
import _ from "lodash";

type AddProductDialogProps = {
  onAdd?: (data: AddProductMutation | UpdateProductMutation) => void;
  title?: string;
};

export function AddProductDialog({
  onAdd,
  title = "Add Product",
}: AddProductDialogProps) {
  const { open, close, getDialogProps } = useDialog();
  const [addProduct] = useAddProductMutation();

  const handleSubmit = async ({
    abv,
    name,
    rating,
    breweryNetPrice,
    ...data
  }: ProductFormSubmitData) => {
    try {
      const result = await addProduct({
        variables: {
          data: {
            name,
            abv: _.isNil(abv) ? null : parseFloat(abv),
            rating: _.isNil(rating) ? null : parseFloat(rating),
            breweryNetPrice: _.isNil(breweryNetPrice)
              ? null
              : toCents(breweryNetPrice),
            ...data,
          },
        },
      });
      if (result.data) {
        onAdd && onAdd(result.data);
        close();

        toast.current?.show({
          severity: MessageSeverity.success,
          summary: "",
          detail: `Added Product ${name}`,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: MessageSeverity.error,
        summary: getMessageToUserFromBackendError(error),
      });
    }
  };

  return (
    <>
      <Button kind="primary" onClick={open} size="sm">
        {title}
      </Button>
      <Dialog {...getDialogProps()} title={title} width="lg">
        <ProductForm onSubmit={handleSubmit} />
      </Dialog>
    </>
  );
}
